"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const authenticated_client_1 = require("./authenticated.client");
class VarsClient extends authenticated_client_1.AuthenticatedClient {
    getDynamicVarKeys(projectId, from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/dynamicvar/keys?from=${from.toISOString()}&to=${to.toISOString()}`);
            return response.payload || [];
        });
    }
    searchDynamicVarKeys(projectId, from, to, searchSubstring) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/dynamicvar/keys?from=${from.toISOString()}&to=${to.toISOString()}&searchSubstring=${searchSubstring}`);
            return response.payload || [];
        });
    }
    getDynamicVarValues(projectId, from, to, key) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/dynamicvar/keys/${encodeURIComponent(key)}` +
                `?from=${from.toISOString()}&to=${to.toISOString()}`);
            return response.payload || {};
        });
    }
    getCustomVars(projectId, pageId) {
        return __awaiter(this, void 0, void 0, function* () {
            const page = pageId ? `?pageId=${pageId}` : '';
            const response = yield this.httpGet(`/v1/projects/${projectId}/custom-vars${page}`);
            return response.payload || [];
        });
    }
    searchCustomVarValues(projectId, cvarKey, searchSubstring) {
        return __awaiter(this, void 0, void 0, function* () {
            const key = `?cvarKey=${cvarKey}`;
            const substring = `&searchSubstring=${searchSubstring}`;
            const response = yield this.httpGet(`/v1/projects/${projectId}/search-custom-var-values${key}${substring}`);
            return response.payload || [];
        });
    }
    getDistinctUrlAppsParts(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/distinct-url-parts`);
            return response.payload || [];
        });
    }
    getMappingAssistantVars(projectId, pageId) {
        return __awaiter(this, void 0, void 0, function* () {
            const page = pageId ? `?pageId=${pageId}` : '';
            const response = yield this.httpGet(`/v1/projects/${projectId}/mapping-assistant-vars${page}`);
            return response.payload || [];
        });
    }
}
exports.VarsClient = VarsClient;
//# sourceMappingURL=vars.client.js.map